/**
 * Converte uma string vinda de input de preço em número.
 *
 * Aceita formatos pt-BR e en-US:
 *   "13000"       -> 13000
 *   "13.000"      -> 13000   (ponto como separador de milhar)
 *   "13.000,50"   -> 13000.5 (vírgula decimal pt-BR)
 *   "99,90"       -> 99.9
 *   "99.90"       -> 99.9    (ponto decimal en-US, sem agrupamento 3 dígitos)
 *   "R$ 1.234,56" -> 1234.56
 *   ""            -> null
 *   "abc"         -> null
 *
 * Heurística: se houver vírgula, ela é o decimal e pontos são milhares.
 * Sem vírgula, pontos seguidos de 3 dígitos finais são milhares;
 * caso contrário, o ponto é decimal.
 */
/**
 * Formata uma string de dígitos (centavos) como moeda BR.
 *   ""     -> ""
 *   "5"    -> "0,05"
 *   "1390" -> "13,90"
 *   "13900"-> "139,00"
 *   "139000"-> "1.390,00"
 */
export function formatCentavosBR(digits) {
  const onlyDigits = String(digits ?? '').replace(/\D/g, '').replace(/^0+(?=\d)/, '');
  if (!onlyDigits) return '';
  const padded = onlyDigits.padStart(3, '0');
  const cents = padded.slice(-2);
  const reaisRaw = padded.slice(0, -2);
  const reais = reaisRaw.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${reais},${cents}`;
}

/**
 * Converte string de dígitos (centavos) em number (reais).
 *   "1390" -> 13.9
 *   ""     -> null
 */
export function centavosToNumber(digits) {
  const onlyDigits = String(digits ?? '').replace(/\D/g, '');
  if (!onlyDigits) return null;
  return parseInt(onlyDigits, 10) / 100;
}

/**
 * Converte um number (reais) em string de dígitos (centavos).
 *   13.9  -> "1390"
 *   100   -> "10000"
 *   null  -> ""
 */
export function numberToCentavos(num) {
  if (num == null || !Number.isFinite(Number(num))) return '';
  return String(Math.round(Number(num) * 100));
}

export function parsePriceInput(raw) {
  if (raw == null) return null;
  const cleaned = String(raw).replace(/[^\d,.-]/g, '');
  if (!cleaned) return null;

  const hasComma = cleaned.includes(',');
  const normalized = hasComma
    ? cleaned.replace(/\./g, '').replace(',', '.')
    : cleaned.replace(/\.(?=\d{3}(\D|$))/g, '');

  const num = parseFloat(normalized);
  return Number.isFinite(num) ? num : null;
}
